import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

// material
import {
	Toolbar,
	AppBar,
	Box,
	makeStyles,
	Button,
	withStyles,
} from "@material-ui/core";

import { goToRoute } from "@/store/actions/navigationActions";
import routePaths from "@/utils/route-paths";

import {
	removeCredentialsFromSession,
	deleteFromSession,
} from "@/utils/session";
import { setShowStudentDetailsInMobile } from "@/store/actions/commonActions";
import { initializeStudentDetails } from "@/store/actions/studentDetailsActions";
import { initializeStudentNotes } from "@/store/actions/notesActions";

const useStyles = makeStyles((theme) => ({
	appBar: {
		backgroundColor: theme.palette.common.white,
	},
	toolbar: {
		paddingTop: theme.spacing(1),
		height: theme.spacing(8.5),
	},
}));

const LogoutButton = withStyles((theme) => ({
	root: {
		color: "#595959",
		"&:hover": {
			color: theme.palette.primary.main,
		},
	},
}))(Button);

export default function MenuBar({ logo }) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const location = useSelector((state) => state.router.location);
	const showLogout = ![routePaths.UNIVERSITY_LOGIN, routePaths.INTERNAL_FAIR_STUDENTS].includes(
		location.pathname
	);
	const handleLogout = () => {
		removeCredentialsFromSession();
		deleteFromSession("registrantCode");
		dispatch(setShowStudentDetailsInMobile(false));
		dispatch(initializeStudentDetails([]));
		dispatch(initializeStudentNotes([]));
		dispatch(goToRoute(routePaths.UNIVERSITY_LOGIN));
	};
	return (
		<Box flexGrow={1} width="100%">
			<AppBar className={classes.appBar} position="fixed">
				<Toolbar className={classes.toolbar}>
					<Box flexGrow={1}>
						<img
							src={logo.src}
							title={logo.title}
							height={"50px"}
							width={"159px"}
							loading="eager"
							alt={logo.alternativeText || logo.name}
						/>
					</Box>
					{showLogout && (
						<LogoutButton onClick={handleLogout} color="primary">
							Logout
						</LogoutButton>
					)}
				</Toolbar>
			</AppBar>
		</Box>
	);
}

MenuBar.propTypes = {
	logo: PropTypes.object.isRequired,
};
